export default __webpack_public_path__ + "static/media/bug-icon.e9fb1102.svg";